import { Outlet } from 'react-router-dom';
import { Box, useTheme } from '@mui/material';

/**
 * Layout específico para el terminal POS
 * Pantalla completa sin sidebar para máximo espacio de trabajo
 */
const POSLayout: React.FC = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        width: '100vw',
        overflow: 'hidden',
        backgroundColor: theme.palette.background.default,
      }}
    >
      <Outlet />
    </Box>
  );
};

export default POSLayout;
